export const year = 2018;
export const month = {
    im: 'Февраль',
    rod: 'Февраля'
};
export const weekDays = [
    {
        full: 'Понедельник',
        short: 'пн'
    },
    {
        full: 'Вторник',
        short: 'вт'
    },
    {
        full: 'Среда',
        short: 'ср'
    },
    {
        full: 'Четверг',
        short: 'чт'
    },
    {
        full: 'Пятница',
        short: 'пт'
    },
    {
        full: 'Суббота',
        short: 'сб'
    },
    {
        full: 'Воскресенье',
        short: 'вс'
    }
];



// WEBPACK FOOTER //
// ./src/static-data/glossary.js